import Phaser from "phaser";
import { StorageService } from "../services/StorageService";
import { store } from "../state/StateStore";

export class TitleScene extends Phaser.Scene {
  constructor() {
    super({ key: "TitleScene" });
  }

  create(): void {
    const { width, height } = this.cameras.main;
    const centerX = width / 2;

    // Background
    this.cameras.main.setBackgroundColor("#1a1a2e");

    // Title
    this.add
      .text(centerX, height * 0.25, "だるま落とし", {
        fontSize: "42px",
        color: "#ffffff",
        fontFamily: "Arial, sans-serif",
        fontStyle: "bold",
        stroke: "#e74c3c",
        strokeThickness: 4,
      })
      .setOrigin(0.5);

    // Subtitle
    this.add
      .text(centerX, height * 0.33, "Swipe Daruma", {
        fontSize: "20px",
        color: "#aaaaaa",
        fontFamily: "Arial, sans-serif",
      })
      .setOrigin(0.5);

    // Draw a small daruma illustration
    this.drawDarumaPreview(centerX, height * 0.5);

    // High score
    const highScore = StorageService.loadHighScore();
    if (highScore > 0) {
      this.add
        .text(centerX, height * 0.68, `High Score: ${highScore}`, {
          fontSize: "18px",
          color: "#ffdd00",
          fontFamily: "Arial, sans-serif",
        })
        .setOrigin(0.5);
    }

    // Tap to start
    const startText = this.add
      .text(centerX, height * 0.78, "Tap to Start", {
        fontSize: "26px",
        color: "#ffffff",
        fontFamily: "Arial, sans-serif",
        fontStyle: "bold",
      })
      .setOrigin(0.5);

    // Blink animation
    this.tweens.add({
      targets: startText,
      alpha: 0.3,
      duration: 800,
      yoyo: true,
      repeat: -1,
      ease: "Sine.easeInOut",
    });

    // Load high score into state
    store.set({ highScore });

    // Tap anywhere to start
    this.input.once("pointerdown", () => {
      store.reset();
      store.set({ highScore });
      this.scene.start("PlayScene");
    });
  }

  private drawDarumaPreview(x: number, y: number): void {
    const g = this.add.graphics();

    // Stack of colored blocks
    const colors = [0xe74c3c, 0x3498db, 0x2ecc71, 0xf39c12, 0x9b59b6];
    const bw = 80;
    const bh = 28;

    for (let i = 0; i < 5; i++) {
      g.fillStyle(colors[i], 1);
      g.fillRoundedRect(
        x - bw / 2,
        y + 60 - i * bh,
        bw,
        bh - 2,
        4
      );
    }

    // Daruma head on top
    g.fillStyle(0xf5f5dc, 1);
    g.fillEllipse(x, y + 60 - 5 * bh - 10, 60, 44);

    // Eyes
    g.fillStyle(0x000000, 1);
    g.fillCircle(x - 10, y + 60 - 5 * bh - 14, 4);
    g.fillCircle(x + 10, y + 60 - 5 * bh - 14, 4);

    // Mouth
    g.fillStyle(0xcc3333, 1);
    g.fillEllipse(x, y + 60 - 5 * bh - 2, 12, 6);
  }
}
